// https://vuex.vuejs.org/en/actions.html

export default {
    languageAction({ commit }) {
        let lang = localStorage.getItem('language');

        if (!lang) {
            lang = 'ru';
        }

        localStorage.setItem('language', lang);

        commit('SET_LANGUAGE', lang);

    },

    menuAction({ commit }, menu) {
        commit('SET_MENU', menu);
    },
    
    setBrand({ commit }, brand) {
        commit('SET_BRAND', brand);
    },
    
    roleAction({ commit }, role) {
        commit('SET_ROLE', role);
    }
}
